/** Quem ja logou neste browser. Cookie e httpOnly: sem isto o splash nao distingue visita fria. */
export const CHAVE_DE_SESSAO_CONHECIDA = "monte-saude:havia-sessao";

export function haviaSessaoConhecida(): boolean {
  try {
    return window.localStorage.getItem(CHAVE_DE_SESSAO_CONHECIDA) === "1";
  } catch {
    return false;
  }
}

export function lembrarSessaoConhecida(): void {
  try {
    window.localStorage.setItem(CHAVE_DE_SESSAO_CONHECIDA, "1");
  } catch {
    // Storage cheio ou modo privado sem quota: o splash some, o login nao.
  }
}

export function esquecerSessaoConhecida(): void {
  try {
    window.localStorage.removeItem(CHAVE_DE_SESSAO_CONHECIDA);
  } catch {
    // idem
  }
}

export function deveExibirVerificacaoDeSessao(entrada: {
  conheciaSessao: boolean;
  pendente: boolean;
  minimoPassou: boolean;
  statusDoLogin?: "idle" | "pending" | "success" | "error" | undefined;
}): boolean {
  if (entrada.statusDoLogin === "error") return false;
  if (entrada.statusDoLogin === "pending") return true;
  if (entrada.statusDoLogin === "success") return !entrada.minimoPassou;
  return entrada.conheciaSessao && (entrada.pendente || !entrada.minimoPassou);
}
